import { render, staticRenderFns } from "./v2val.vue?vue&type=template&id=3f71de23&scoped=true&"
import script from "./v2val.vue?vue&type=script&lang=js&"
export * from "./v2val.vue?vue&type=script&lang=js&"
import style0 from "./v2val.vue?vue&type=style&index=0&id=3f71de23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71de23",
  null
  
)

export default component.exports